window.sweet=window.sweet||{},window.sweet.q=sweet.q||[],
window.sweet.init=function(e){this.cid=e;},window.sweet.track=function()
{this.q.push(arguments)};var a=document.createElement("script"),
m=document.getElementsByTagName("script")[0];a.async=1,
a.src="https://track.sweetanalytics.com/sweet.min.js",m.parentNode.insertBefore(a,m);
 
sweet.init('AT-69c1a815dab16');
 
analytics.subscribe("page_viewed", event => {
  sweet.track('pageview', 1);
});
 
analytics.subscribe("checkout_completed", event => {
  sweet.track("addTransaction", { 
    transaction_id: event.data.checkout.order.id, 
    total: event.data.checkout.totalPrice.amount,
    tax: event.data.checkout.totalTax.amount,
    shipping: event.data.checkout.shippingLine.price.amount, 
    address1: event.data.checkout.billingAddress.address1,
    address2: event.data.checkout.billingAddress.address2, 
    zip: event.data.checkout.billingAddress.zip, 
    city: event.data.checkout.billingAddress.city,
    state: event.data.checkout.billingAddress.province,
    country: event.data.checkout.billingAddress.country,
    email: event.data.checkout.email
  })
  
  var baseUrl = event.context.document.location.origin
  for(let i=0; i < event.data.checkout.lineItems.length; i+=1) {
    var lineItem = event.data.checkout.lineItems[i]
    var item = {
      transaction_id: event.data.checkout.order.id,
      id: lineItem.variant.sku || lineItem.variant.id,
      name: lineItem.title,
      category: lineItem.variant.product.type,
      price: lineItem.variant.price.amount, 
      qty: lineItem.quantity,
      url: baseUrl + lineItem.variant.product.url,
      image: lineItem.variant.image.src
    }
    sweet.track('addItem', item);
  }
  sweet.track('transaction');
});